const LOG_LEVELS = {
    TRACE: 10,
    DEBUG: 20,
    INFO: 30,
    WARN: 40,
    ERROR: 50,
    NONE: 100,
};
const isProduction = process.env.NODE_ENV === 'production';
export class PenaLogger {
    constructor(context) {
        this.context = context;
        this.currentLevel = this.determineInitialLogLevel();
    }
    determineInitialLogLevel() {
        // 1. Check local storage override if in a browser environment
        if (typeof window !== 'undefined' && window.localStorage) {
            try {
                const storedLevel = window.localStorage.getItem('PENA_LOG_LEVEL');
                if (storedLevel && LOG_LEVELS[storedLevel] !== undefined) {
                    return storedLevel;
                }
            }
            catch (e) {
                // ignore local storage errors (e.g. quota exceeded or disabled)
            }
        }
        // 2. Default fallback based on environment
        return isProduction ? 'ERROR' : 'DEBUG';
    }
    setLevel(level) {
        this.currentLevel = level;
        if (typeof window !== 'undefined' && window.localStorage) {
            try {
                window.localStorage.setItem('PENA_LOG_LEVEL', level);
            }
            catch (e) {
                // ignore
            }
        }
    }
    getLevel() {
        return this.currentLevel;
    }
    createContext(context) {
        return new PenaLogger(context);
    }
    formatMessage(level, message) {
        const parts = [];
        // Add prefix with current time and level
        const timestamp = new Date().toISOString();
        parts.push(`[${timestamp}] [${level}]`);
        // Add context if available
        if (this.context) {
            parts.push(`[${this.context}]`);
        }
        // Usually message is string, but if not we just push it as is
        if (typeof message === 'string') {
            parts.push(message);
            return [parts.join(' ')];
        }
        else {
            return [parts.join(' '), message];
        }
    }
    shouldLog(level) {
        return LOG_LEVELS[level] >= LOG_LEVELS[this.currentLevel];
    }
    trace(message, ...args) {
        if (this.shouldLog('TRACE')) {
            const formatted = this.formatMessage('TRACE', message);
            // eslint-disable-next-line no-console
            console.trace(...formatted, ...args);
        }
    }
    debug(message, ...args) {
        if (this.shouldLog('DEBUG')) {
            const formatted = this.formatMessage('DEBUG', message);
            // eslint-disable-next-line no-console
            console.debug(...formatted, ...args);
        }
    }
    info(message, ...args) {
        if (this.shouldLog('INFO')) {
            const formatted = this.formatMessage('INFO', message);
            // eslint-disable-next-line no-console
            console.info(...formatted, ...args);
        }
    }
    warn(message, ...args) {
        if (this.shouldLog('WARN')) {
            const formatted = this.formatMessage('WARN', message);
            // eslint-disable-next-line no-console
            console.warn(...formatted, ...args);
        }
    }
    error(message, ...args) {
        if (this.shouldLog('ERROR')) {
            const formatted = this.formatMessage('ERROR', message);
            // eslint-disable-next-line no-console
            console.error(...formatted, ...args);
            // Hook for remote error tracking (Sentry, Datadog, etc.)
            // if (isProduction) {
            //   sendToRemoteTracker(message, args, this.context);
            // }
        }
    }
}
// Default export instance for backward compatibility
export const logger = new PenaLogger();
